// import useStyles from './ReportsIndexTable.styles'
import {Box, Button, IconButton, Tooltip} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import ReportsTable from 'modules/reports/components/Table'
import ReportsTableColumn from 'modules/reports/components/Table/Column'
import useCore from 'modules/reports/hooks/core'
import useModal from 'modules/reports/hooks/modal'
import ReportsDownloadModal from 'modules/reports/modals/Download'
import Report from 'modules/reports/models/Report'
import React from 'react'
import ReportsIndexTableActions from './Actions'
import ReportsIndexTableOverlay from './Overlay'
import {useHistory} from 'react-router'

type Props = {}

function ReportsIndexTable(props: Props) {
  const {t, pt, p} = useCore('reports', 'components', 'IndexTable')
  const modal = useModal()
  const history = useHistory()
  // const classes = useStyles()

  function renderFallback() {
    return (
      <Box padding={4} alignItems="center" textAlign="center">
        <Box marginBottom={2} fontSize="h5.fontSize" fontWeight="fontWeightLight">
          {pt('fallback.line1')}
          <br />
          {pt('fallback.line2')}
        </Box>

        <Button variant="contained" color="primary" data-testid={p('new-button')}>
          <AddIcon /> {pt('fallback.new-button')}
        </Button>
      </Box>
    )
  }

  function handleDownload(report: Report) {
    modal.open(ReportsDownloadModal, {report})
  }

  function handleOpenReport(report: Report) {
    history.push(`/reports/${report.id}`)
  }

  return (
    <Box paddingX={4} paddingY={2} overflow="hidden" height="100%">
      <ReportsTable prefix={p()} fallback={renderFallback} onClick={handleOpenReport} scroll>
        <ReportsTableColumn name="name" width={200} grow={1} />

        <ReportsTableColumn name="group" width={120}>
          {(report: Report) => report.group.name}
        </ReportsTableColumn>

        <ReportsTableColumn name="scheduled" width={100}>
          {(report: Report) => t(`commons.boolean.${report.scheduled ? 'yes' : 'no'}`)}
        </ReportsTableColumn>

        <ReportsTableColumn name="last_run_at" width={140}>
          {(report: Report) => report.formattedLastRunAt}
        </ReportsTableColumn>

        <ReportsTableColumn name="created_by" width={160}>
          {(report: Report) => report.createdByUser.name}
        </ReportsTableColumn>

        <ReportsTableColumn name="actions" width={98} noLabel>
          {(report: Report) => (
            <>
              <Tooltip title={pt('download')}>
                <IconButton
                  aria-label={pt('download')}
                  onClick={() => handleDownload(report)}
                  data-testid={p('download')}
                >
                  <GetAppIcon />
                </IconButton>
              </Tooltip>

              <ReportsIndexTableActions />
            </>
          )}
        </ReportsTableColumn>

        <ReportsIndexTableOverlay />
      </ReportsTable>
    </Box>
  )
}

export default ReportsIndexTable
